import { JSONPath as jsonPath } from 'jsonpath-plus';

type JsonType = Record<string | number | symbol, unknown>;

type ExtractByPath = (params: { json: JsonType; path: string }) => unknown;
export const extractByPath: ExtractByPath = ({ json, path }) => {
  const value = jsonPath({ path, json });
  if (Array.isArray(value)) {
    return value[0];
  }

  return value;
};
